"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PortalCompatContextProvider: ()=>_portalCompatContext.PortalCompatContextProvider,
    usePortalCompat: ()=>_portalCompatContext.usePortalCompat
});
const _portalCompatContext = require("./PortalCompatContext");
 //# sourceMappingURL=index.js.map

//# sourceMappingURL=index.js.map